function e(input) {
  // shortcut to escape the input string for csv encoding
  if (input === true) {
    return 'Y';
  }
  if (input === false) {
    return 'N';
  }
  if (input === null || input === undefined) {
    return '';
  }
  if (typeof input.indexOf == 'function') {
    if (input.indexOf('"') >= 0) {
      input = input.replace(/"/g, '""');
    }
    if (input.search(/("|,|\n)/g) >= 0) {
      input = '"' + input + '"';
    }
  }
  return input;
}

// searialize the list of broadcasts as a CSV string
export function broadcastListToCSVString(broadcasts) {
  var csvContent =
    'Name,Channel,Start,Stop,Private,Ticketed,Flex,Ticket Price,BoxCaster,Total Views,Total Minutes Viewed\n';
  broadcasts.forEach((b, index) => {
    var dataString = [
      e(b.name),
      e(b.channel_id),
      e(b.starts_at),
      e(b.stops_at),
      e(b.is_private),
      e(b.is_ticketed),
      e(b.is_ticketed && b.free_variant != 'none'),
      e(b.ticket_price),
      e(b.boxcaster_name),
      e(b.total_view_count),
      e(b.total_minutes_viewed),
    ].join(',');
    csvContent += index < broadcasts.length ? dataString + '\n' : dataString;
  });
  return csvContent;
}

// if a url is passed as a protocol-relative url (e.g. "//uploads.boxcast.com/foo.jpg"), make
// sure to preprend a protocol. this is required for some 3rd party application integrations.
export function ensureHttpOnProtocolRelativeUrl(url) {
  if (url.startsWith('//')) {
    url = 'http:' + url;
  }
  return url;
}



// WEBPACK FOOTER //
// ./app/utils/broadcast.js